import { ModalProps, PdfViewerModalContentProps } from "../../../../commons/types/modal";
import * as icons from "../../../../resources/icons";
import Icon from "../../components/Icon/Icon";
import IconButton from "../../components/IconButton/IconButton";
import Modal from "../../components/Modal/Modal";

import PdfViewerPartial from "./PdfViewerPartial";

type Props = ModalProps<PdfViewerModalContentProps>;

const PdfViewerModalParial = ({
  close,
  url,
  isOffline,
  isOfflineAndMailToPrintIsEnabled,
  hidePrint = false,
  hideSend = false
}: Props) => {
  return (
    <Modal
      width="xl"
      layout="noPadding"
      closeButton={<IconButton onClick={() => close()} icon={<Icon source={icons.IconSmallCross} />} />}
    >
      <PdfViewerPartial
        isOffline={isOffline}
        url={url}
        isOfflineAndMailToPrintIsEnabled={isOfflineAndMailToPrintIsEnabled}
        hidePrint={hidePrint}
        hideSend={hideSend}
        onClose={close}
      />
    </Modal>
  );
};

export default PdfViewerModalParial;
